import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PGAvailabilitySelection, PGUserContact, PgAvailabilitySelectData } from 'pg-lib/models/booking.model';
import { TimetableDataHour, TimetableDataList } from 'pg-lib/models/timetable.model';
import { CustomerCareService } from 'pg-lib/services/customer-care.service';
import { EnvironmentService } from 'pg-lib/services/environment.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
@Component({
    selector: 'app-totem-customer-care-book',
    templateUrl: './totem-customer-care-book.component.html',
    styleUrls: ['./totem-customer-care-book.component.scss'],
    standalone: false
})
export class TotemCustomerCareBookComponent implements OnInit {

    constructor(private router:Router, private environmentService:EnvironmentService, private customerCareService:CustomerCareService, private localizationService:LocalizationService) { }

    isLoading = false;

    availabilityData:Array<PgAvailabilitySelectData> = null;
    filteredAvailabilityData:Array<PgAvailabilitySelectData> = null;
    
    languageOptions:Array<{ value: string, text: string }> = null;
    selectedLanguage:string = null;

    selectedAvailability:PGAvailabilitySelection = null;

    editUserContact:{ name:string, via:'email'|'phone', value: string, phone:string } = null;

    additionalInformations:string = null;

    warnNoLongerAvailable = false;

    totemId:string = null;

    bookingRequested = false;

    ngOnInit(): void {
        this.editUserContact = {
            name: null,
            via: null,
            value: null,
            phone: null
        }
        
        if(this.isChatEnabled()) {    
            this._resetBooking()
        }
    }

    private _resetBooking() {
        this.languageOptions = [];

        for(let _language of this.localizationService.availableApplicationLanguages) {
            this.languageOptions.push({ value: _language, text: this.localizationService.languageLabels[_language] })

            if(this.localizationService.currentLanguage == _language) {
                this.selectedLanguage = _language;
            }
        }

        this.isLoading = true;

        this.customerCareService.getAvailability(null, null).subscribe((data) => {
            this.isLoading = false;
            this.availabilityData = data;
            this.filterAvailabilityData()
        }, () => {
            this.isLoading = false;
        })
    }

    onAvailabilitySelected(availability:PGAvailabilitySelection) {
        this.selectedAvailability = availability;
    }

    canRequestBooking() {
        return this.selectedLanguage != null && this.selectedAvailability != null  && this.editUserContact.name != null && this.editUserContact.name != '' && this.editUserContact.via != null;
    }

    requestBooking() {
        if(this.canRequestBooking()) {

            this.isLoading = true;

            let _userContact = new PGUserContact();
            _userContact.name = this.editUserContact.name;
            
            if(this.editUserContact.via == 'email') {
                _userContact.email = this.editUserContact.value;
                _userContact.phone = this.editUserContact.phone;
            }
            else if(this.editUserContact.via == 'phone') {
                _userContact.phone = this.editUserContact.value;
            }

            this.customerCareService.createBooking(this.selectedAvailability.id, this.selectedLanguage, this.selectedAvailability, _userContact, this.totemId, this.additionalInformations).subscribe((data) => {

                this.isLoading = false;
    
                if(data == null) {
                    this.isLoading = true;

                    let _cDateSplit = this.selectedAvailability.date.split('-');

                    let _cYear = parseInt(_cDateSplit[0]);
                    let _cMonth = parseInt(_cDateSplit[1]);
                    let _cDay = parseInt(_cDateSplit[2]);

                    this.customerCareService.getBookingsCountDay(this.selectedAvailability.id, _cYear, _cMonth, _cDay).subscribe((count) => {
                        this.isLoading = false;
    
                        if(count != null && count[this.selectedAvailability.begin] != null) {
                            if(this.selectedAvailability.availability.current > count[this.selectedAvailability.begin]) {
                                this.warnNoLongerAvailable = true;
                                this._resetBooking();
                            }
                        }
                    })
                }
                else {
                    this.bookingRequested = true;
                }
            })
        }
    }

    onLanguageChange() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
            this.filterAvailabilityData();
        }, 250)
    }

    private _splitHoursMinutes = 30
    private _dayMinutes = (60 * 24)

    private _stringToMinutes(val:string) {
        let _split = val.split(':');
        return parseInt(_split[0]) * 60 + parseInt(_split[1]);
    }

    private _minutesToString(val:number) {
        val = val % this._dayMinutes;

        let _minVal = (val % 60).toString() 
        if(_minVal.length < 2) _minVal = '0' + _minVal;
        
        let _hourVal = Math.floor(val / 60).toString();
        if(_hourVal.length < 2) _hourVal = '0' + _hourVal;

        return _hourVal + ':' + _minVal;
    }

    filterAvailabilityData() {
        this.filteredAvailabilityData = []
        
        for(let _availability of this.availabilityData) {
            if(_availability.languages == null || _availability.languages.indexOf(this.selectedLanguage) != -1) {
                _availability.availability = new TimetableDataList(_availability.availability.toData())

                for(let _slot of _availability.availability.list) {
                    let _splittedHours:Array<TimetableDataHour> = []

                    for(let _hour of _slot.hours) {
                        let _beginTime = this._stringToMinutes(_hour.begin);
                        let _endTime = this._stringToMinutes(_hour.end);
                        if(_endTime < _beginTime) _endTime += this._dayMinutes

                        while(_beginTime < _endTime) {
                            let _splitTime = _beginTime + this._splitHoursMinutes;

                            _splittedHours.push({
                                days: _hour.days,
                                begin: this._minutesToString(_beginTime),
                                end: this._minutesToString(_splitTime)
                            })

                            _beginTime = _splitTime;
                        }
                    }

                    _slot.hours = _splittedHours;
                }

                this.filteredAvailabilityData.push(_availability)
            }
        }
    }

    isChatEnabled() {
        return this.environmentService.isWebsocketEnabled();
    }

    goBackToTotem() {
        this.router.navigate(['/'])
    }
}
